export default __webpack_public_path__ + "static/media/Image-Benefit3.748fc946.png";